export interface INavigationState {
  expandViewStripe: boolean,
  showPaymentPopup: boolean,
  paymentModal: {
    show: boolean,
  },
  showLoader: boolean,
  showChangeMailScreen: boolean,
  // do we need this? can use paymentModal.show
  showPaymentByClick: boolean,
  purchaseFlowScreen: {
    email: string,
    url: string,
    payment_system: string,
    showPDFUpselling: boolean,
    showChatUpsale: boolean,
    showFakeHardwar: boolean,
    showSupplementsUpsale: boolean,
    showSuccessScreen: boolean,
    screenFlow: string[],
    currentScreenIndex: number,
    upselPDF: boolean,
  },
  showSpecialOffer: boolean;
  showModalDiscount: boolean;
  discountShownOnce: boolean,
}

const state: INavigationState = {
	expandViewStripe: true,
	showPaymentPopup: false,
	paymentModal: {
		show: false,
	},
	showLoader: false,
	showChangeMailScreen: false,
	showPaymentByClick: false,
  purchaseFlowScreen: {
    email: '',
    url: '',
    payment_system: '',
    showPDFUpselling: false,
    showChatUpsale: false,
    showFakeHardwar: false,
    showSupplementsUpsale: false,
    showSuccessScreen: false,
    screenFlow: ['PDFUpselling', 'ChatUpsale', 'SuccessScreen'],
    currentScreenIndex: 0,
    upselPDF: false,
  },
  showSpecialOffer: false,
  showModalDiscount: false,
  discountShownOnce: false,
};

export default state;
